import { render, staticRenderFns } from "./UserListStats.vue?vue&type=template&id=3c820e1b&"
import script from "./UserListStats.vue?vue&type=script&lang=ts&"
export * from "./UserListStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports